define(function (require) {
	"use strict";

	var LE = require("app");
	var Template = require("personalization-user-management-templates/lob.tmpl");
	var Button = require("ui/button/Button");
	var BaseAnchorView = require("personalization-views/BaseAnchorView");
	var positionsUtility = require("personalization-utils/positionsUtility");
	var KpContent = require("ui.components/kpContent/kpContent");

	var LobView = {};
	function moduleDefinition(LEPersonalization, LE, Backbone, Marionette, $, _) {

		LobView = BaseAnchorView.extend({
			template: Template,
			withUIComponents: true,
			className: "lob-anchor-view anchor hide",
			ui: {
				lobEditButton: ".lob-edit-button",
				currentLobState: ".current-status-container",
				knowledgePack: ".kp",
				descriptionLabel: ".sub-title",
				currentLobStateContainer: ".lob-container",
				lobEditButtonContainer: ".lob-bubble-button"
			},
			uiComponents: {
				editButton: {
					type: Button,
					options: {
						el: "view.ui.lobEditButton",
						permutation: Button.PERMUTATION.BTN_PRIMARY
					},
					events: {
						"click": "_onEditButtonClick"
					}
				},
				kpContent: {
					type : KpContent,
					options : {
						container: "view.ui.knowledgePack",
						contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
						KPLink: LE.translator.translate("LEPersonalization.userManagement.lob.title.learnMore"),
						kpID: "manage-lines-of-business"
					}
				}
			},

			initialize: function (options) {
				LEPersonalization.logger.info("initializing", "LobView:initialize", options);
				this.anchorSelector = options.anchorSelector;
				this.featureId = options.featureId;
				BaseAnchorView.prototype.initialize.call(this, options);
			},
			onRender: function (options) {
				LEPersonalization.logger.info("rendering", "LobView:onRender", options);
				var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.LEFT, positionsUtility.POSITION_Y.TOP);
				if (offset) {
					this.$el.css(offset);
				}
				this.ui.descriptionLabel.text(LE.translator.translate("LEPersonalization.userManagement.lob.description"));
			},
			onClose: function () {
				LEPersonalization.logger.debug("closing view", "LobView:onClose");
			},
			setLobValue: function (lobSettingValue) { //Sets lob site-setting value
				LEPersonalization.logger.debug("sets retrieved Lob enabled indication", "LobView:setLobValue", lobSettingValue);
				this.lobSettingValue = lobSettingValue;
				if (lobSettingValue) {
					this.ui.currentLobState.text(LE.translator.translate("LEPersonalization.userManagement.lob.enabled.label"));
				} else {
					this.ui.currentLobState.text(LE.translator.translate("LEPersonalization.userManagement.lob.disabled.label"));
				}
			},
			_onEditButtonClick: function () {
				LEPersonalization.logger.debug("Edit button was clicked", "LobView:_onEditButtonClick");
				this.trigger("lob:navigateToFeatureEdit");
			},
			setUiState: function (isExistingLobs) {
				LEPersonalization.logger.debug("Adjusts description text and the whole component if lobs exist", "LobView:setUiState", isExistingLobs);
				if (isExistingLobs && this.lobSettingValue) {
					this.ui.descriptionLabel.text(LE.translator.translate("LEPersonalization.userManagement.lob.description.disabled.functionality"));
					this.ui.currentLobStateContainer.addClass("hide");
					this.ui.lobEditButtonContainer.addClass("hide");
				}
				var isLobTabHidden = !this.lobSettingValue; // false - means LOB tab is hidden and then its not the last tab
				this.$el.toggleClass("lobs-tabs-hidden", isLobTabHidden);
				this.$el.removeClass("hide");
			}
		});
	}

	LE.module("LEPersonalization", moduleDefinition);

	return LobView;
});
